import * as types from '../actions/action-types';
import initialState from './initial-state';

export default function dotMailerTrackerReducer(
    state = initialState.dotMailerTracker,
    action
) {
    if (action.type === types.LOAD_DOT_MAILER_TRACKER_ENTRIES_SUCCESS) {
        return {
            ...state,
            areDotMailerEntriesLoadedSuccessfully: true,
            dotMailerTrackerApiMessage: action.successMessage
        };
    }

    if (action.type === types.LOAD_DOT_MAILER_TRACKER_ENTRIES_ERROR) {
        return {
            ...state,
            areDotMailerEntriesLoadedSuccessfully: false,
            dotMailerTrackerApiMessage: action.errorMessage
        };
    }

    return state;
}
